import React from 'react'
import Cards from './Cards'
import Footer from './Footer'
import Header from './Header'

const Container = () => {
    return (
        <div className="container border border-3 p-1">
            <Header />
            <Cards />
            <Footer/>
        </div>
    )
}

export default Container
